import { render, staticRenderFns } from "./gmp-post.vue?vue&type=template&id=6dc808a0&"
import script from "./gmp-post.vue?vue&type=script&lang=js&"
export * from "./gmp-post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports